module.exports = __webpack_public_path__ + "static/media/game-board-alt.bc42c547.svg";